export default function getLinkIdFromString(string: string) {
  return string.toLowerCase().split(" ").join("_");
}
